/**
 * Hero Slider - Seeksu Jewels
 * Dynamic Shopify Section Slider with Auto-play and Navigation
 */

(function() {
    'use strict';

    // Initialize all hero sliders on the page
    function initAllSliders() {
        const heroSections = document.querySelectorAll('.hero[data-section-id]');
        heroSections.forEach(section => {
            new HeroSlider(section);
        });
    }

    // Hero Slider Class
    class HeroSlider {
        constructor(section) {
            this.section = section;
            this.sectionId = section.dataset.sectionId;
            this.slider = section.querySelector('.hero-slider');
            this.slides = section.querySelectorAll('.hero-slide');
            this.prevBtn = section.querySelector('.slider-prev');
            this.nextBtn = section.querySelector('.slider-next');

            // Get settings from data attributes
            this.autoPlay = section.dataset.autoplay === 'true';
            this.autoPlayInterval = parseInt(section.dataset.speed) || 5000;
            this.transitionDuration = 800;
            this.slideCount = parseInt(section.dataset.slideCount) || this.slides.length;

            // State
            this.currentSlide = 0;
            this.slideInterval = null;
            this.isTransitioning = false;

            this.init();
        }

        init() {
            if (!this.slider || this.slides.length === 0) return;
            if (this.slideCount <= 1) return; // No need for slider with single slide

            // Add event listeners
            if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goToPrevSlide());
            if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goToNextSlide());

            // Start auto-play
            this.startAutoPlay();

            // Pause on hover
            this.slider.addEventListener('mouseenter', () => this.stopAutoPlay());
            this.slider.addEventListener('mouseleave', () => this.startAutoPlay());

            // Touch/Swipe support
            this.initTouchEvents();
        }

        goToSlide(index) {
            if (this.isTransitioning || index === this.currentSlide) return;
            if (index < 0 || index >= this.slides.length) return;

            this.isTransitioning = true;

            // Remove active class from current slide
            this.slides[this.currentSlide].classList.remove('active');

            // Update current index
            this.currentSlide = index;

            // Add active class to new slide
            this.slides[this.currentSlide].classList.add('active');

            // Reset transition lock
            setTimeout(() => {
                this.isTransitioning = false;
            }, this.transitionDuration);
        }

        goToNextSlide() {
            const nextIndex = (this.currentSlide + 1) % this.slides.length;
            this.goToSlide(nextIndex);
        }

        goToPrevSlide() {
            const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
            this.goToSlide(prevIndex);
        }

        startAutoPlay() {
            if (!this.autoPlay) return;
            this.stopAutoPlay();
            this.slideInterval = setInterval(() => this.goToNextSlide(), this.autoPlayInterval);
        }

        stopAutoPlay() {
            if (this.slideInterval) {
                clearInterval(this.slideInterval);
                this.slideInterval = null;
            }
        }

        initTouchEvents() {
            let touchStartX = 0;
            const swipeThreshold = 50;

            this.slider.addEventListener('touchstart', (e) => {
                touchStartX = e.changedTouches[0].screenX;
            }, { passive: true });

            this.slider.addEventListener('touchend', (e) => {
                const touchEndX = e.changedTouches[0].screenX;
                const diff = touchStartX - touchEndX;

                if (Math.abs(diff) > swipeThreshold) {
                    if (diff > 0) {
                        this.goToNextSlide();
                    } else {
                        this.goToPrevSlide();
                    }
                }
            }, { passive: true });
        }
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllSliders);
    } else {
        initAllSliders();
    }

    // Re-initialize on Shopify section reload
    if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', (e) => {
            const section = e.target.querySelector('.hero[data-section-id]');
            if (section) {
                new HeroSlider(section);
            }
        });
    }

})();